<button
  type="button"
  class="block w-full py-2 px-4 bg-surface dark:bg-surface-darkmode text-on-surface dark:text-on-surface-darkmode hover:bg-surface-highlight dark:hover:bg-surface-highlight-darkmode cursor-pointer text-start text-sm"
>
  <ng-content />
</button>
